import { Box } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { useLocale } from '@koopajs/react';
import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useAppContext } from '@koopajs/react';
import MoreTimeIcon from '@mui/icons-material/MoreTime';
import { useMultipleDocumentsInMemoryDropzone } from 'components/hooks/useMultipleDocumentsInMemoryDropzone';
interface IUploadMeetingButtonProps {
  isProcessing?: boolean;
  variant?: 'contained' | 'outlined';
  buttonLabel?: string;
}

export const UploadMeetingButton: React.FC<IUploadMeetingButtonProps> = (props) => {
  const { isProcessing: isReloadingMeetings, variant, buttonLabel } = props;
  const { setComponentContext } = useAppContext();

  const { t } = useLocale();
  const history = useHistory();

  const { dropzone, isProcessing, files } = useMultipleDocumentsInMemoryDropzone({
    isStoringFileInMemory: true,
    isMultiple: true
  });

  useEffect(() => {
    if (files) {
      history.push({ pathname: `/uploaded-meetings` });
      setComponentContext('uploadedMeetings', { files });
    }
  }, [JSON.stringify(files)]);

  return (
    <Box {...dropzone.getRootProps()} data-cy="upload-meeting-button_container">
      <input {...dropzone.getInputProps()} data-cy="upload-meeting-button_input" />

      <LoadingButton
        onClick={dropzone.open}
        startIcon={<MoreTimeIcon />}
        loading={isProcessing}
        loadingPosition="start"
        disabled={isReloadingMeetings}
        variant={variant}
        data-cy="upload-meeting-button"
      >
        <span>{buttonLabel ? buttonLabel : t('common:add')}</span>
      </LoadingButton>
    </Box>
  );
};
